(() => {
  const initHeader = (header) => {
    if (!header || header.dataset.aiokingHeaderSkinInitialized === 'true') return;
    header.dataset.aiokingHeaderSkinInitialized = 'true';

    const desktop = header.querySelector('.foundation-header__desktop');
    const topItems = desktop ? [...desktop.querySelectorAll(':scope > ul > li')].filter((item) => item.querySelector(':scope > ul')) : [];
    const setOpen = (item, open) => {
      item.toggleAttribute('data-menu-open', open);
      item.querySelector(':scope > a')?.setAttribute('aria-expanded', String(open));
    };
    const closeAll = (except = null) => topItems.forEach((item) => { if (item !== except) setOpen(item, false); });

    topItems.forEach((item) => {
      const link = item.querySelector(':scope > a');
      if (!link) return;
      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', 'false');
      item.addEventListener('pointerenter', () => {
        if (matchMedia('(pointer:fine)').matches) {
          closeAll(item);
          setOpen(item, true);
        }
      });
      item.addEventListener('pointerleave', (event) => {
        if (matchMedia('(pointer:fine)').matches && !item.contains(event.relatedTarget) && !item.matches(':focus-within')) setOpen(item, false);
      });
    });

    header.addEventListener('focusout', (event) => {
      const item = event.target.closest('.foundation-header__desktop > ul > li');
      if (item && !item.contains(event.relatedTarget)) setOpen(item, false);
    });
    header.addEventListener('keydown', (event) => {
      const link = event.target.closest('.foundation-header__desktop > ul > li > a');
      if (!link) return;
      const item = link.parentElement;
      if ((event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') && item.querySelector(':scope > ul')) {
        event.preventDefault();
        const next = !item.hasAttribute('data-menu-open');
        closeAll(next ? item : null);
        setOpen(item, next);
      } else if (event.key === 'Escape' && item.hasAttribute('data-menu-open')) {
        event.preventDefault();
        setOpen(item, false);
        link.focus();
      }
    });
    document.addEventListener('click', (event) => {
      if (!header.contains(event.target)) closeAll();
    });

    const drawer = header.querySelector('.foundation-mobile');
    if (!drawer) return;
    [...drawer.querySelectorAll('li')].filter((item) => item.querySelector(':scope > ul')).forEach((item, index) => {
      const link = item.querySelector(':scope > a');
      const submenu = item.querySelector(':scope > ul');
      if (!link || !submenu) return;
      item.dataset.mobileBranch = '';
      submenu.id = `${drawer.id}-submenu-${index + 1}`;
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'foundation-mobile__branch-toggle';
      toggle.setAttribute('aria-controls', submenu.id);
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', `Expand ${link.textContent.trim()}`);
      item.insertBefore(toggle, submenu);
      toggle.addEventListener('click', () => {
        const open = item.toggleAttribute('data-mobile-menu-open');
        toggle.setAttribute('aria-expanded', String(open));
        toggle.setAttribute('aria-label', `${open ? 'Collapse' : 'Expand'} ${link.textContent.trim()}`);
      });
    });
  };

  const init = () => document.querySelectorAll('[data-aioking-header-skin]').forEach(initHeader);
  init();
  document.addEventListener('shopify:section:load', init);
})();
